import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
// vue-echarts renders a custom <x-vue-echarts> element and injects its sizing rule
// (display:block; width:100%; height:100%) at runtime via document.adoptedStyleSheets.
// That rule is UNLAYERED, so it overrides any Tailwind height utility (h-64/h-80/…) — those
// live in @layer utilities, which always loses to unlayered declarations. Charts therefore
// must size their HEIGHT via an inline :style (which outranks the adopted sheet); a utility
// class collapses to height:100% of a card that has no definite height → 0 → blank chart.
// (This stylesheet import is redundant with the adopted sheet but kept as documentation.)
import 'vue-echarts/style.css'
import i18n from './libs/i18n'
import { installLiveSearch } from './libs/liveSearch'
import { createSentry } from './libs/sentry'
import router from './router'
import { useAppStore } from './stores/app'

const app = createApp(App)

app.use(createPinia())
installLiveSearch()

// Verify the session (GET /api/v1/ping) before mounting, so a stale localStorage login is
// cleared when the JWT cookie is gone — the router's guard then routes accordingly.
const appStore = useAppStore()
appStore.verifySession().finally(() => {
    app.use(i18n)
    app.use(router)
    app.use(ui)

    createSentry(app)
    // Mount once the first navigation has settled: before that the route has no meta, so the
    // signed-in shell would render (and start its requests) on the way to the login page.
    void router.isReady().then(() => app.mount('#app'))
})
